import { ActionTree, Commit, } from 'vuex';
import { IMenuSearchState, Timeout, ILookupResult } from './types';
import { searchMenuItems } from './utils';

const debounceTime = 150;
const timeoutHandle: { debounce: Timeout } = { debounce: 0 };

export async function performSearch(
  searchText: string,
  commit: Commit,
  getters: any,
  rootGetters: any
) {
  if (searchText.length < 3) {
    return;
  }

  const navData = rootGetters['NavigationState/navData'];
  const eventsData = rootGetters['NavigationState/eventsData'];

  let menus: any[] = [];
  if (navData?.menus) {
    menus = menus.concat(navData?.menus);
  }
  if (eventsData?.menus) {
    menus = menus.concat(eventsData?.menus);
  }
  const menuResults = searchMenuItems(searchText, menus);
  commit('lookup', searchText);

  if (menuResults?.length > 0) {
    commit('setSelectedResultIndex', -1);
    commit('results', menuResults);
  } else {
    commit('results', []);
  }
  commit('setIsSearching', false);
}

const actions: ActionTree<IMenuSearchState, any> = {
  selectPreviousResult({ commit, getters }) {
    const results = getters.results;
    let current = getters.selectedResultIndex;
    if (current < 0) {
      current = results?.length || -1;
    }
    if (current > 0) {
      commit('setSelectedResultIndex', current - 1);
    } else {
      commit('setSelectedResultIndex', -1);
    }
  },
  selectNextResult({ commit, getters }) {
    const current = getters.selectedResultIndex;
    const results = getters.results;
    const upperBound = results?.length || 0;
    if (current < upperBound - 1) {
      commit('setSelectedResultIndex', current + 1);
    } else {
      commit('setSelectedResultIndex', -1);
    }
  },
  invokeActionOnSelectedResult({ getters, commit }) {
    const result: ILookupResult = getters.selectedResult;
    if (result) {
      const { href, target } = result;
      window.open(href, target);
    }
  },
  async lookup({ commit, getters, rootGetters }, searchText: string) {
    commit('setIsSearching', true);
    commit('results', []); // reset results
    if (timeoutHandle.debounce) {
      clearTimeout(timeoutHandle.debounce);
      timeoutHandle.debounce = 0;
    }
    timeoutHandle.debounce = setTimeout(
      async () => await performSearch(searchText, commit, getters, rootGetters),
      debounceTime
    );
  },
};

export default actions;
